var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"pa-0"},[_c('v-toolbar',{attrs:{"dense":"","color":"red lighten-1"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Lotações")])],1)],1),_c('v-card-text',[_c('WorkstationList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }